import React from "react";
import { Modal } from "react-bootstrap";
import ModalFormColor from "./ModalFormColor";

const ModalColor = ({ show, handleClose, color }) => {
  console.log(color);

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Modificar Color</Modal.Title>
      </Modal.Header>

      <ModalFormColor color={color} handleClose={handleClose} />
    </Modal>
  );
};

export default ModalColor;